import { components } from 'react-select';
import s from './index.module.scss';

export const SingleValueBase = props => {
  const { data: country } = props;
  return (
    <components.SingleValue {...props}>
      <div className={s.base}>
        <div className={s.base_name}>{country.label}</div>
      </div>
    </components.SingleValue>
  );
};
